export default __webpack_public_path__ + "static/card-2-5427679facca381a9451e4368a8d5880.png";